export default "/images/linkedin.svg?9e52cf326e0bbf3cd9a3378906c0d35c";